import React from 'react';
import { CheckIcon } from 'lucide-react';
interface MultiSelectQuestionProps {
  options: string[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
}
export function MultiSelectQuestion({
  options,
  selectedValues,
  onChange
}: MultiSelectQuestionProps) {
  const handleToggle = (option: string) => {
    if (selectedValues.includes(option)) {
      onChange(selectedValues.filter(v => v !== option));
    } else {
      onChange([...selectedValues, option]);
    }
  };
  return <div className="space-y-3" data-id="element-86">
      {options.map((option, index) => {
      const isSelected = selectedValues.includes(option);
      return <label key={index} className={`flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all min-h-[56px] ${isSelected ? 'border-crown-red bg-crown-red bg-opacity-10' : 'border-crown-border bg-crown-surface hover:border-crown-muted'}`} data-id="element-87">
            <input type="checkbox" checked={isSelected} onChange={() => handleToggle(option)} className="sr-only" data-id="element-88" />
            <div className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 ${isSelected ? 'border-crown-red bg-crown-red' : 'border-crown-border'}`} data-id="element-89">
              {isSelected && <CheckIcon className="w-4 h-4 text-white" data-id="element-90" />}
            </div>
            <span className={`ml-3 text-base ${isSelected ? 'text-crown-text font-medium' : 'text-crown-body'}`} data-id="element-91">
              {option}
            </span>
          </label>;
    })}
    </div>;
}